import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const fmtInt = (n) =>
  new Intl.NumberFormat("es-ES", { maximumFractionDigits: 0 }).format(n || 0);

export const fmtDec = (n, d = 2) =>
  new Intl.NumberFormat("es-ES", {
    minimumFractionDigits: d,
    maximumFractionDigits: d,
  }).format(n || 0);

export const fmtMWh = (n) => fmtInt((n || 0) / 1000) + " MWh";

export const fmtEur = (n) => {
  const v = n || 0;
  if (Math.abs(v) >= 1_000_000)
    return new Intl.NumberFormat("es-ES", { maximumFractionDigits: 1 }).format(v / 1_000_000) + " M€";
  if (Math.abs(v) >= 1_000)
    return new Intl.NumberFormat("es-ES", { maximumFractionDigits: 0 }).format(v / 1_000) + " k€";
  return new Intl.NumberFormat("es-ES", { maximumFractionDigits: 0 }).format(v) + " €";
};

export const fmtEurFull = (n) =>
  new Intl.NumberFormat("es-ES", { maximumFractionDigits: 0 }).format(n || 0) + " €";

export const viabilidadClass = (v) => {
  if (v === "Alta") return "alta";
  if (v === "Condicionada") return "cond";
  return "rev";
};

export const viabilidadColor = (v) => {
  if (v === "Alta") return "#15803D";
  if (v === "Condicionada") return "#B45309";
  return "#991B1B";
};
